// Extensions
interface Date {
    toUnix(): number;
}

Date.prototype['toUnix'] = function() {
    return  Math.round(this.getTime() / 1000);
};
